import request from "../services/requestService";
import * as apiServices from "../services/apiServices";

// Add Article Action
export const addArticleAction = (params, requestMethod = request) => {
  return requestMethod(apiServices.addArticle(params))
    .then(response => {
      const payload = response.data;
      return payload;
    })
    .catch(error => {
      console.error("Error submitting article:", error);
      throw error;
    });
};
// Update Article Action
export const updateArticleAction = (params, id, requestMethod = request) => {
  return requestMethod(apiServices.updateArticle(params, id))
    .then(response => {
      const payload = response.data;
      return payload;
    })
    .catch(error => {
      console.error("Error updating article:", error);
      throw error;
    });
};
// List Articles List Action
export const getArticlesAction = (params, requestMethod = request) => {
  return requestMethod(apiServices.getArticlesApi(params))
    .then(response => {
      console.log("from articles action", response.data);
      const payload = response.data.data;
      localStorage.setItem("articlesList", JSON.stringify(payload));

      return response.data;
    })
    .catch(error => {
      console.error("Error fetching articles:", error);
      throw error;
    });
};
// tags Article Action
export const addTagsAction = (params, requestMethod = request) => {
  return requestMethod(apiServices.articlesTags(params))
    .then(response => {
      const payload = response.data;
      return payload;
    })
    .catch(error => {
      console.error("Error Tags:", error);
      throw error;
    });
};
export const addTags = (params, requestMethod = request) => {
  return requestMethod(apiServices.addTags(params))
    .then(response => {
      const payload = response.data;
      return payload;
    })
    .catch(error => {
      console.error("Error Tags:", error);
      throw error;
    });
};

export const getArticleDetailsAction = (id, requestMethod = request) => {
  return requestMethod(apiServices.getArticleDetailsById(id))
    .then(response => {
      return response.data;
    })
    .catch(error => {
      console.error("Error fetch article:", error);
      throw error;
    });
};
export const getOtherArticles = (id, requestMethod = request) => {
  return requestMethod(apiServices.getOtherArticles(id))
    .then(response => {
      return response.data;
    })
    .catch(error => {
      console.error("Error fetch article:", error);
      throw error;
    });
};
export const getLatestArticles = (params, requestMethod = request) => {
  return requestMethod(apiServices.getLatestArticlesApi(params))
    .then(response => {
      return response.data;
    })
    .catch(error => {
      console.error("Error fetch latest articles:", error);
      throw error;
    });
};
